import './AnimatedScorebox.scss'

const AnimatedScorebox = ({ players, gameObjects }) => {
    if(players.length === 0) return (<></>)

    var items = []
    for (var i = 0; i < players.length; i++) {
        items.push(<div className='rowflex' style={{ minWidth: 150, }} key={i.toString()}>
            <p>{players[i].name+":"}</p>
            <p style={{ color: players[i].solveTime?'var(--time)':'var(--negative)'}}>{players[i].solveTime?((players[i].solveTime - gameObjects.startTime) / 1000).toFixed(3)+'s':'Unfinished'}</p>
            <div style={{width: 5}}></div>
            <p style={{ float: 'right', color: players[i].solveTime?'var(--positive)':'var(--time)'}}>{(players[i].score-players[i].scoreGain) + " + "+players[i].scoreGain}</p>
            <p style={{ float: 'right', color: players[i].solveTime?'var(--positive)':'var(--time)'}}>{"= "+players[i].score}</p>
        </div>)
    }

    return (
        <div className='colflex'>
            {items}
        </div>
    )
}

export default AnimatedScorebox